
import axios from 'axios';
import Vue from 'vue';
import { S3_Attachment } from '@/schema/attachment';
import { attachmentDownload } from '@/api/attachment';
import AttachmentUploader from '@/components/_Attachments/AttachmentUploader.vue';

export default Vue.extend({
	components: {
		AttachmentUploader
	},
	props: {
		participant: { type: String, required: true },
		legalEntity: { type: String, required: true },
		visible: { type: Boolean, required: true },
		fileList: { type: Array, required: false, default: () => [] },
		onUpload: { type: Function, default: () => {} },
		onRemove: { type: Function, default: () => {} }
	},
	data() {
		return {
			loading: false
		};
	},
	methods: {
		handleClose() {
			this.$emit('dialog-close', {});
		},
		handlePreview(file: S3_Attachment) {
			attachmentDownload(this.participant, file);
		},

		async handleRemove(file: S3_Attachment) {
			if (this.onRemove) {
				this.onRemove(file);
			}
		},

		handleAttachmentAdded(attachment: S3_Attachment) {
			if (this.onUpload) {
				this.onUpload(attachment);
			}
		},

		setLoading(isLoading: boolean) {
			this.loading = isLoading;
		}
	}
});

